import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { authenticated } from '../auth/auth.guard';

import { CommunicationComponent } from './communication/communication.component';
import { FirstContactComponent } from './first-contact/first-contact.component';
import { PoliticalNegotiationComponent } from './political-negotiation/political-negotiation.component';
import { CommunicationEstablishedComponent } from './communication-established/communication-established.component';
import { CommunicationFailedComponent } from './communication-failed/communication-failed.component';

const routes: Routes = [
  {
    path: 'firstContact',
    canActivate: [authenticated],
    component: FirstContactComponent
  },
  {
    path: 'communication',
    canActivate: [authenticated],
    component: CommunicationComponent
  },
  {
    path: 'communicationEstablished',
    canActivate: [authenticated],
    component: CommunicationEstablishedComponent
  },
  {
    path: 'communicationEstablishedFailed',
    canActivate: [authenticated],
    component: CommunicationFailedComponent
  },
  {
    path: 'negotiation',
    canActivate: [authenticated],
    component: PoliticalNegotiationComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StateDepartmentRoutingModule { }
